/**
 * Cooperation 4 in Life Design https://www.figma.com/design/aKqGUBjSWByWm6LN2nBZdr/Ext.-Life-Illustration-Lib.-v2.2.0?node-id=19735-13532&t=R23dJwukrCRXWIqC-4
 */
import { Box, type BoxProps } from '@mui/material';
import COOPERATION_SVG from '@tbd/life-assets/misc/cooperation.svg';

export function CooperationImage(props: BoxProps) {
  const { sx, ...rest } = props;
  return (
    <Box
      sx={{
        backgroundImage: `url(${COOPERATION_SVG})`,
        backgroundSize: 'cover',
        height: '200px',
        aspectRatio: '16/12',
        ...sx,
      }}
      {...rest}
    />
  );
}
